// src/utils/azureUtils.js

import { getAuth } from 'firebase/auth';

export const postFormData = async (url, data) => {
  const response = await fetch(url, {
    method: 'POST',
    body: data,
  });
  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }
  return await response.text();
};

export const fetchAzureUserProfile = async (email) => {
  const getUserProfileUrl = process.env.REACT_APP_GET_KBEAN_USER_PROFILE_BY_EMAIL_URL;
  const apiKey = process.env.REACT_APP_SEARCH_API_KEY;

  const response = await fetch(getUserProfileUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ApiKey: apiKey,
    },
    body: JSON.stringify({ EmailAddress: email }),
  });

  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }

  return await response.json();
};

export const updateAzureUserProfileUsername = async (userName, email) => {
  const updateUsernameUrl = process.env.REACT_APP_UPDATE_KBEAN_USERNAME;
  const apiKey = process.env.REACT_APP_SEARCH_API_KEY;

  const response = await fetch(updateUsernameUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ApiKey: apiKey,
    },
    body: JSON.stringify({ UserName: userName, EmailAddress: email }),
  });

  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }

  return await response.json();
};

export const checkUsernameAvailability = async (userName) => {
  const checkUserNameAvailabilityURL = process.env.REACT_APP_CHECK_USERNAME_AVAILABILITY_URL;
  const response = await fetch(`${checkUserNameAvailabilityURL}${userName}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data.response.message === 'UserName available';
};

export const fetchCustomToken = async (uid) => {
  try {
    const firebaseBackendUrl = process.env.REACT_APP_FIREBASE_BACKEND;

    // Ensure the URL does not have a trailing slash
    const response = await fetch(`${firebaseBackendUrl}/generateCustomToken`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ uid }), // Make sure `uid` is valid and passed correctly
    });

    if (!response.ok) {
      // Log error details for better debugging
      const errorDetails = await response.text();
      console.error(`Failed to generate custom token: ${errorDetails}`);
      throw new Error(`Failed to generate custom token: ${response.statusText}`);
    }

    const data = await response.json();
    return data.customToken;
  } catch (error) {
    console.error('Error in fetchCustomToken:', error);
    throw error; // Re-throw the error after logging it
  }
};

export const socialAuthenticationJWT = async () => {
  const auth = getAuth();
  const user = auth.currentUser;
  const token = await user.getIdToken();

  const data = new FormData();
  data.append("fbtoken", token);
  data.append("currentUser", JSON.stringify(user));

  const socialLoginJWTURL = process.env.REACT_APP_SOCIAL_LOGIN_JWT_URL;

  const response = await fetch(socialLoginJWTURL, {
    method: "POST",
    body: data,
  });

  if (!response.ok) {
    throw new Error(`API request failed with status ${response.status}`);
  }

  const authData = new FormData();
  authData.append("fbtoken", token);

  const socialAuthenticateURL = process.env.REACT_APP_SOCIAL_AUTHENTICATE_URL;

  const authResponse = await fetch(socialAuthenticateURL, {
    method: "POST",
    body: authData,
  });

  if (!authResponse.ok) {
    throw new Error(`Auth API request failed with status ${authResponse.status}`);
  }

  const authResponseData = await authResponse.text();
  localStorage.setItem("authResponseData", authResponseData);
  console.log(`authResponseData for JWT Login: ${authResponseData}`);
};
